<template>
	<div class="shopList main-content-padding" v-if="$auth.hasPermi('system:cooperativeShop-query')">
		<Tip ref="tips" type="warning" :content="'店铺列表统计项不包含二级团长商品相关数据，二级团长商品无法发起商家协作申请。'"></Tip>
		<div class="cut-line"></div>
		<Panel :contentPaddingTop="12" class="pallet">
			<div class="illustrate flex-row-align-center">
				<div class="progress-box flex-just-between flex-row-align-center">
					<div class="flex-row-align-center">
						<p class="yx-color-text-primary mr-8 font-h6-regular">友情版注册奖励</p>
						<el-progress :percentage="percentage" :stroke-width="12" :show-text="false"></el-progress>
						<div
							:class="['ml-8 yx-color-primary  flex-just-center flex-row', percentage >= 100 ? 'font-h6-medium' : 'font-h6-regular']"
							style="width: 40px"
						>
							{{ percentage >= 100 ? '已完成' : `${percentage}%` }}
						</div>
					</div>
					<div class="flex-row-align-center font-h6-regular yx-color-text-regular cursor-pointer" @click="openRules">
						<span>奖励规则</span>
						<i class="el-icon-arrow-right ml-2" style="transform: scale(0.9)"></i>
					</div>
				</div>
				<div class="yx-color-text-regular cursor-pointer font-h4-regular hover" @click="toUrl">
					<i class="el-icon-document"></i>
					<span class="ml-6">使用教程</span>
				</div>
			</div>
			<div class="search">
				<platformTab @change="handleClick" :showAll="false" :platformId="platformId" />
				<search v-show="showPlatformContent" :partnerArr="partnerArr" ref="search" @onSubmit="onSubmit" />
			</div>
		</Panel>
		<panel :contentPaddingTop="10" :contentPaddingBottom="0" v-show="showPlatformContent">
			<multi-table
				:key="platformId"
				ref="multiTable"
				:page="pageInfo"
				:columns="columns"
				@gePartnerList="tabGetList"
				@getSortList="sortHandle"
				:list="list"
				:total="total"
				v-loading="loading"
			>
				<empty ref="empty" slot="empty"></empty>
			</multi-table>
		</panel>

		<!-- 邀请弹框 -->
		<invite-dialog ref="inviteDialog" :teamName="teamName" :platformId="platformId" />

		<!-- 编辑备注 -->
		<remark-dialog ref="remarkDialog" @refresh="getList" />

		<!-- 协作记录 -->
		<bind-record-drawer ref="bindRecordDrawer" @refresh="getList" :platformId="platformId" />

		<!-- 协作规则 -->
		<collbaorate-rules-drawer ref="collbaorateRulesDrawer" @refresh="getList" :platformId="platformId" />

		<reward-rules ref="rewardRules" />

		<!--多团长确认弹窗-->
		<multi-regimental
			ref="multiRegimental"
			@nextStep="
				params => {
					$refs.inviteDialog.show(params);
				}
			"
		/>

		<!--样品自动协作弹窗--->
		<edit-order-dialog ref="editOrderDialog"></edit-order-dialog>

		<!--修改店铺对接人-->
		<shopContactDrawer ref="shopContactDrawer" @refresh="getList" />
	</div>
</template>
<script>
import { mapGetters } from 'vuex';
import { zsRoleType } from '@/utils/dataMap';
import Search from './components/search.vue';
import getColumns from './columns';
import inviteDialog from './components/inviteDialog.vue';
import remarkDialog from './components/remarkDialog.vue';
import bindRecordDrawer from './components/bindRecordDrawer.vue';
import collbaorateRulesDrawer from './components/collbaorateRulesDrawer.vue';
import { cooperativeShopList } from '@/api/cooperativeShop';
import { toCamelCase } from '@/utils/common';
import { shopCooperationStatus, shopAuthorityList, getBindCount } from '@/api/cooperativeShop';
import { commonList } from '@/api/cooperationProgress';
import { accountInfo } from '@/api/common';
import multiRegimental from './components/multiRegimental.vue';
import editOrderDialog from './components/editOrderDialog.vue';
import { platformMixin } from '@rd/rd-ui';
import rewardRules from './components/rewardRules.vue';
import empty from '@/views/common/empty/index.vue';
import shopContactDrawer from './components/shopContactDrawer/shopContactDrawer.vue';
import { getProductConfig } from '@/api/settings.js';
export default {
	components: {
		Search,
		inviteDialog,
		remarkDialog,
		bindRecordDrawer,
		collbaorateRulesDrawer,
		multiRegimental,
		editOrderDialog,
		rewardRules,
		empty,
		shopContactDrawer,
	},
	mixins: [platformMixin],
	computed: {
		...mapGetters(['defaultPlatform', 'isShopPartnerDataView']),
		columns() {
			return getColumns(this);
		},
	},
	created() {
		this.getBindCount();
		this.getList();
		this.searchList();
		this.getCooperationStatus();
		this.getTeamInfo();
		this.getProductDuplicate();
	},
	data() {
		return {
			platformId: '',
			list: [],
			loading: false,
			params: {},
			pageInfo: {
				page_index: 1,
				page_size: 20,
			},
			total: 0,
			cooperationStatus: false,
			partnerArr: [],
			teamName: '',
			percentage: 0,
			followUpState: 0,
		};
	},
	methods: {
		async getList() {
			this.loading = true;
			try {
				const { platformId, pageInfo, params } = this;
				const { list = [], page = {} } = await cooperativeShopList({ ...pageInfo, ...params, platformId });
				this.list = list.map(item => {
					return {
						...item,
						operations: this.getButtons(item),
					};
				});
				this.total = `${page.itemTotal || 0}`;
			} finally {
				this.loading = false;
			}
		},
		async searchList() {
			//店铺运营
			const { code, data } = await commonList({ role_id: zsRoleType.id, all_status: 1 });
			if (code == 0) {
				this.partnerArr = data;
			}
		},
		getButtons(item) {
			const { cooperationStatus, platformId } = this;
			const editOrder = {
				label: '协同订单范围',
				type: 'text',
				isShow: this.$auth.hasPermi('system:cooperativeShop:collaboration-editOrder'),
				click: ({ outerShopId, collaborativeStatus }) => {
					this.$refs.editOrderDialog.show(platformId, outerShopId, collaborativeStatus);
				},
			};
			const invite = {
				label: '协作邀请',
				type: 'text',
				tooltipContent: this.$isSp(this.platformId)
					? '视频号暂未开放'
					: item.collaborativeStatus == 1
					? '绑定状态的店铺无法发起邀请，如需操作请先取消原绑定。'
					: cooperationStatus
					? ''
					: '商团协作协作未开启, 请联系管理员开启',
				notSelf: item.collaborativeStatus == 1 || !cooperationStatus || this.$isSp(this.platformId),
				disabled: item.collaborativeStatus == 1 || !cooperationStatus || this.$isSp(this.platformId),
				placement: 'top',
				isShow: this.$auth.hasPermi('system:cooperativeShop:collaboration-invitation'),
				click: ({ outerShopId }) => {
					this.openType(outerShopId);
				},
			};
			const rules = {
				label: '协作规则',
				type: 'text',
				tooltipContent: item.isSetRule ? '' : '店铺不允许创建单店协作规则',
				notSelf: !item.isSetRule,
				disabled: !item.isSetRule,
				placement: 'top',
				isShow: this.$auth.hasPermi('system:cooperativeShop:cooperation-rule'),
				click: ({ outerShopId }) => {
					this.$refs.collbaorateRulesDrawer.show(outerShopId);
				},
			};
			const recond = {
				label: '绑定记录',
				type: 'text',
				classtype: 2,
				isShow: this.$auth.hasPermi('system:cooperativeShop:cooperation-bind'),
				click: ({ outerShopId }) => {
					this.$refs.bindRecordDrawer.show(outerShopId);
				},
			};
			const remark = {
				label: '编辑备注',
				type: 'text',
				classtype: 2,
				isShow: this.$auth.hasPermi('system:cooperativeShop:cooperation-remark'),
				click: ({ remarks, outerShopId }) => {
					this.$refs.remarkDialog.show(remarks, outerShopId);
				},
			};
			const followUp = {
				label: '修改对接人',
				type: 'text',
				classtype: 2,
				isShow: this.$isPlatOr(['Dy', 'Ks']) && this.followUpState && this.$auth.hasPermi('system:cooperativeShop:collaboration-communicating'),
				click: row => {
					this.$refs.shopContactDrawer.show(row);
				},
			};
			return [editOrder, invite, rules, recond, remark, followUp].filter(item => item.isShow);
		},
		handleClick(val) {
			this.platformId = val;
			if (!this.showPlatformContent) return;
			this.$refs.search.onClear();
			this.getProductDuplicate();
			this.getList();
		},
		sortHandle({ prop, order = 'default' }) {
			if (order) {
				const obj = {
					ascending: 'asc',
					descending: 'desc',
				};
				let str;
				if (prop === 'sales30Days') {
					str = 'sales_30_days';
				} else if (prop === 'estimatedServiceFee30Days') {
					str = 'estimated_service_fee_30_days';
				} else {
					str = toCamelCase(prop);
				}
				this.params.sortOrder = `ss.${str} ${obj[order]}`;
			} else {
				this.params.sortOrder = undefined;
			}
			this.getList();
		},
		tabGetList(obj) {
			const { page_index, page_size } = obj;
			this.pageInfo.page_index = page_index;
			this.pageInfo.page_size = page_size;
			this.getList();
		},
		onSubmit(val) {
			this.params = val;
			this.getList();
		},
		async getCooperationStatus() {
			const { cooperationStatus = false } = await shopCooperationStatus();
			this.cooperationStatus = cooperationStatus;
		},
		toUrl() {
			window.open('https://yangxuan.feishu.cn/docx/GNQ7dcB4EogjSFxZEXjcMRR6n4z?from=from_copylink', '_blank');
		},
		async getTeamInfo() {
			const { code, data } = await accountInfo({});
			if (code == 0) {
				this.teamName = data.team_name;
			}
		},
		async openType(outerShopId) {
			const { platformId } = this;
			const { code, data } = await shopAuthorityList({ platformId, outerShopId });
			if (code !== 0) return;
			if (!data.list.length) {
				this.$message.error('您暂未认领该店铺下的商品，无法发起协作');
				return;
			}
			data.list.length > 1
				? this.$refs.multiRegimental.show(data.list, outerShopId)
				: this.$refs.inviteDialog.show({ outerShopId, authorityIds: data.list.map(val => val.authorityId) });
		},
		async getBindCount() {
			const { TotalCount = 200, bindCount = 0 } = await getBindCount();
			this.percentage = parseFloat(((parseInt(bindCount) / parseInt(TotalCount)) * 100).toPrecision(12));
		},
		openRules() {
			this.$refs.rewardRules.show();
		},
		// 获取撞单规则
		async getProductDuplicate() {
			const { data, code } = await getProductConfig({ platformId: this.platformId });
			if (code === 0) {
				this.followUpState = data.productDuplicateAlone;
			}
		},
	},
};
</script>
<style lang="less" scoped>
.shopList {
	.bread-crumb {
		padding: 12px 24px 12px 24px;
		display: flex;
		align-items: center;
		justify-content: space-between;
		border-bottom: 1px solid @color-gy3;
		background: @color-gy1;
		.bread-crumb-left {
			color: @color-gy9;
			font-size: 14px;
			line-height: 28px;
		}
	}
	.cut-line {
		background-color: @color-gy2;
		height: 16px;
	}
	.header-pos {
		position: relative;
	}
	.illustrate {
		position: absolute;
		z-index: 11;
		right: 24px;
		top: 10px;
		.progress-box {
			width: 362px;
			border-radius: 20px;
			padding: 0 16px;
			height: 33px;
			background: linear-gradient(93deg, rgba(240, 245, 255, 0.5) 0%, #f0f5ff 34%, #eaf1ff 98%);
			margin-right: 40px;
			::v-deep .el-progress-bar__outer {
				width: 140px;
			}
			::v-deep .el-progress-bar__outer {
				background-color: @color-gy1;
			}
			::v-deep .el-progress--line {
				display: flex;
				justify-content: space-between;
			}
			::v-deep .el-progress-bar__inner {
				background: linear-gradient(90deg, #71a5ff 0%, #2475ff 100%) !important;
			}
		}
	}
	::v-deep .table-header-row .cell {
		height: 32px;
		line-height: 32px;
	}
	/deep/ .panel-content {
		border-radius: 0px;
	}
}
</style>
